// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.promoStories-module_container__mYDNE {
    width: 100%;
    height: 100dvh;
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: center;
    user-select: none;
    position: absolute;
    left: 0;
    top: 0;
}

.promoStories-module_topButtonWrapper__v4ml3 {
    display: flex;
    width: 50%;
    justify-content: right;
}

.promoStories-module_topButtonWrapperRight__TfSD4 {
    justify-content: right;
}

.promoStories-module_topButtonWrapperLeft__quKy5 {
    justify-content: left;
}

.promoStories-module_overlay__vVZem {
    display: flex;
    flex-direction: row;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100dvh;

    & div {
        width: 50%;
    }
}

.promoStories-module_storiesContent__m1CPT {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-height: 100%;
    overflow: hidden;
    pointer-events: none;

    & button {
        cursor: pointer;
        position: relative;
        z-index: var(--zindex-stories-buttons);
    }
}

.promoStories-module_progressRow__FCV1u {
    display: flex;
    flex-direction: row;
    padding: 0 24px;
    width: 100%;
    box-sizing: border-box;
    position: fixed;
    top: 16px;
    z-index: var(--zindex-stories-progress);
}

.promoStories-module_step__JYzq6 {
    display: inline-flex;
    flex-grow: 1;
    height: 2px;
    border-radius: 4px;
    background: var(--grey_16_lc);
    margin-right: 4px;
    position: relative;

    &:last-child {
        margin-right: 0;
    }
}

.promoStories-module_stepInverted__z6myk {
    background: var(--grey_28_tr);
}

.promoStories-module_stepBg__D4An4 {
    height: 2px;
    border-radius: 4px;
    background: var(--purple_100);
}

.promoStories-module_stepBgInverted__Y_3AK {
    background: var(--white_base);
}

.promoStories-module_storyContainer__mDo6V {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100dvh;
    background: var(--backgroundA);
    background-size: contain;
    position: relative;
}

.promoStories-module_bottomButtonsWrapper__Hh2B7 {
    display: flex;
    justify-content: right;
    column-gap: 24px;
    width: 100%;
    max-width: 888px;
    box-sizing: border-box;
}

.promoStories-module_justifyCenter__pfcsr {
    justify-content: center;
    max-width: 480px;
}

.promoStories-module_storyBottomButtons__I1o5Q {
    display: flex;
    box-sizing: border-box;
    justify-content: center;
    padding: 24px;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
}

.promoStories-module_storyContentButton__RjBjv {
    margin-top: 24px;
    text-align: center;
}

.promoStories-module_storyInfo__i09I7 {
    display: flex;
    gap: 16px;
    height: 50%;
    padding: 24px 32px;
    flex-direction: column;
    align-items: center;
    align-self: stretch;
}

.promoStories-module_storyInfoMiddle__tCqAh {
    order: 2;
}

.promoStories-module_storyImg__OR1P8 {
    display: flex;
    height: 50%;
    padding: 0 32px;
    flex-direction: column;
    align-items: center;
    align-self: stretch;

    & img {
        max-width: 100%;
        max-height: 100%;
    }
}

.promoStories-module_storyContent__FlqBZ {
    margin: 0 auto;
    padding: 88px 0;
    max-height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1 0 0;
}

.promoStories-module_storyContentTop__kBtmW {
    padding: 88px 0 0 0;
}


@media screen and (min-width: 481px) {
    .promoStories-module_storyContent__FlqBZ {
        max-width: 480px;
    }

    .promoStories-module_progressRow__FCV1u {
        max-width: 504px;
    }
}

@media screen and (min-width: 708px) {
    .promoStories-module_fullWidthImage__RvAcG {
        background-size: cover;
    }

    .promoStories-module_storyContent__FlqBZ {
        max-width: calc(((100% - 168px) / 6) * 4 + 120px);
    }

    .promoStories-module_progressRow__FCV1u {
        max-width: 100%;
    }
}

@media screen and (max-width: 480px) and (-webkit-min-device-pixel-ratio: 2), screen and (max-width: 480px) and (min-resolution: 192dpi) {
    .promoStories-module_storyContainer__mDo6V {
        background: var(--backgroundAx2);
    }
}

@media screen and (max-width: 480px) and (-webkit-min-device-pixel-ratio: 3), screen and (max-width: 480px) and (min-resolution: 288dpi) {
    .promoStories-module_storyContainer__mDo6V {
        background: var(--backgroundAx3);
    }
}

@media screen and (min-width: 481px) {
    .promoStories-module_storyContainer__mDo6V {
        background: var(--backgroundB);
    }
}

@media screen and (min-width: 481px) and (-webkit-min-device-pixel-ratio: 2), screen and (min-width: 481px) and (min-resolution: 192dpi) {
    .promoStories-module_storyContainer__mDo6V {
        background: var(--backgroundBx2);
    }
}

@media screen and (min-width: 481px) and (-webkit-min-device-pixel-ratio: 3), screen and (min-width: 481px) and (min-resolution: 288dpi) {
    .promoStories-module_storyContainer__mDo6V {
        background: var(--backgroundBx3);
    }
}

@media screen and (min-width: 889px) {
    .promoStories-module_storyContent__FlqBZ {
        max-width: 600px;
    }

    .promoStories-module_progressRow__FCV1u {
        max-width: 888px;
    }
}

@media screen and (min-width: 1920px) {
    .promoStories-module_progressRow__FCV1u {
        top: 16px;
    }
}

@keyframes promoStories-module_slideRightToLeft__g92D3 {
    0% {
        transform: translateX(100%);
    }
    100% {
        transform: translateX(0);
    }
}

@keyframes promoStories-module_slideLeftToRight__jSE47 {
    0% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(0);
    }
}

.promoStories-module_forward__at36L .promoStories-module_animatedContent__xktoh {
    animation: promoStories-module_slideRightToLeft__g92D3 0.3s ease-in-out forwards;
}

.promoStories-module_backwards__h7ZYY .promoStories-module_animatedContent__xktoh {
    animation: promoStories-module_slideLeftToRight__jSE47 0.3s ease-in-out forwards;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Stories/promoStories.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,OAAO;IACP,MAAM;AACV;;AAEA;IACI,aAAa;IACb,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,cAAc;;IAEd;QACI,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;;IAEpB;QACI,eAAe;QACf,kBAAkB;QAClB,sCAAsC;IAC1C;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,SAAS;IACT,uCAAuC;AAC3C;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;;IAElB;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,8BAA8B;IAC9B,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;;IAEnB;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,iDAAiD;IACrD;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,gCAAgC;IACpC;AACJ;;AAEA;IACI;QACI,gCAAgC;IACpC;AACJ;;AAEA;IACI;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,gCAAgC;IACpC;AACJ;;AAEA;IACI;QACI,gCAAgC;IACpC;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,gFAAqD;AACzD;;AAEA;IACI,gFAAqD;AACzD","sourcesContent":[".container {\n    width: 100%;\n    height: 100dvh;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    align-items: center;\n    user-select: none;\n    position: absolute;\n    left: 0;\n    top: 0;\n}\n\n.topButtonWrapper {\n    display: flex;\n    width: 50%;\n    justify-content: right;\n}\n\n.topButtonWrapperRight {\n    justify-content: right;\n}\n\n.topButtonWrapperLeft {\n    justify-content: left;\n}\n\n.overlay {\n    display: flex;\n    flex-direction: row;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100dvh;\n\n    & div {\n        width: 50%;\n    }\n}\n\n.storiesContent {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    max-height: 100%;\n    overflow: hidden;\n    pointer-events: none;\n\n    & button {\n        cursor: pointer;\n        position: relative;\n        z-index: var(--zindex-stories-buttons);\n    }\n}\n\n.progressRow {\n    display: flex;\n    flex-direction: row;\n    padding: 0 24px;\n    width: 100%;\n    box-sizing: border-box;\n    position: fixed;\n    top: 16px;\n    z-index: var(--zindex-stories-progress);\n}\n\n.step {\n    display: inline-flex;\n    flex-grow: 1;\n    height: 2px;\n    border-radius: 4px;\n    background: var(--grey_16_lc);\n    margin-right: 4px;\n    position: relative;\n\n    &:last-child {\n        margin-right: 0;\n    }\n}\n\n.stepInverted {\n    background: var(--grey_28_tr);\n}\n\n.stepBg {\n    height: 2px;\n    border-radius: 4px;\n    background: var(--purple_100);\n}\n\n.stepBgInverted {\n    background: var(--white_base);\n}\n\n.storyContainer {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    min-height: 100dvh;\n    background: var(--backgroundA);\n    background-size: contain;\n    position: relative;\n}\n\n.bottomButtonsWrapper {\n    display: flex;\n    justify-content: right;\n    column-gap: 24px;\n    width: 100%;\n    max-width: 888px;\n    box-sizing: border-box;\n}\n\n.justifyCenter {\n    justify-content: center;\n    max-width: 480px;\n}\n\n.storyBottomButtons {\n    display: flex;\n    box-sizing: border-box;\n    justify-content: center;\n    padding: 24px;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n}\n\n.storyContentButton {\n    margin-top: 24px;\n    text-align: center;\n}\n\n.storyInfo {\n    display: flex;\n    gap: 16px;\n    height: 50%;\n    padding: 24px 32px;\n    flex-direction: column;\n    align-items: center;\n    align-self: stretch;\n}\n\n.storyInfoMiddle {\n    order: 2;\n}\n\n.storyImg {\n    display: flex;\n    height: 50%;\n    padding: 0 32px;\n    flex-direction: column;\n    align-items: center;\n    align-self: stretch;\n\n    & img {\n        max-width: 100%;\n        max-height: 100%;\n    }\n}\n\n.storyContent {\n    margin: 0 auto;\n    padding: 88px 0;\n    max-height: 100%;\n    display: flex;\n    flex-direction: column;\n    flex: 1 0 0;\n}\n\n.storyContentTop {\n    padding: 88px 0 0 0;\n}\n\n\n@media screen and (min-width: 481px) {\n    .storyContent {\n        max-width: 480px;\n    }\n\n    .progressRow {\n        max-width: 504px;\n    }\n}\n\n@media screen and (min-width: 708px) {\n    .fullWidthImage {\n        background-size: cover;\n    }\n\n    .storyContent {\n        max-width: calc(((100% - 168px) / 6) * 4 + 120px);\n    }\n\n    .progressRow {\n        max-width: 100%;\n    }\n}\n\n@media screen and (max-width: 480px) and (-webkit-min-device-pixel-ratio: 2), screen and (max-width: 480px) and (min-resolution: 192dpi) {\n    .storyContainer {\n        background: var(--backgroundAx2);\n    }\n}\n\n@media screen and (max-width: 480px) and (-webkit-min-device-pixel-ratio: 3), screen and (max-width: 480px) and (min-resolution: 288dpi) {\n    .storyContainer {\n        background: var(--backgroundAx3);\n    }\n}\n\n@media screen and (min-width: 481px) {\n    .storyContainer {\n        background: var(--backgroundB);\n    }\n}\n\n@media screen and (min-width: 481px) and (-webkit-min-device-pixel-ratio: 2), screen and (min-width: 481px) and (min-resolution: 192dpi) {\n    .storyContainer {\n        background: var(--backgroundBx2);\n    }\n}\n\n@media screen and (min-width: 481px) and (-webkit-min-device-pixel-ratio: 3), screen and (min-width: 481px) and (min-resolution: 288dpi) {\n    .storyContainer {\n        background: var(--backgroundBx3);\n    }\n}\n\n@media screen and (min-width: 889px) {\n    .storyContent {\n        max-width: 600px;\n    }\n\n    .progressRow {\n        max-width: 888px;\n    }\n}\n\n@media screen and (min-width: 1920px) {\n    .progressRow {\n        top: 16px;\n    }\n}\n\n@keyframes slideRightToLeft {\n    0% {\n        transform: translateX(100%);\n    }\n    100% {\n        transform: translateX(0);\n    }\n}\n\n@keyframes slideLeftToRight {\n    0% {\n        transform: translateX(-100%);\n    }\n    100% {\n        transform: translateX(0);\n    }\n}\n\n.forward .animatedContent {\n    animation: slideRightToLeft 0.3s ease-in-out forwards;\n}\n\n.backwards .animatedContent {\n    animation: slideLeftToRight 0.3s ease-in-out forwards;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `promoStories-module_container__mYDNE`,
	"topButtonWrapper": `promoStories-module_topButtonWrapper__v4ml3`,
	"topButtonWrapperRight": `promoStories-module_topButtonWrapperRight__TfSD4`,
	"topButtonWrapperLeft": `promoStories-module_topButtonWrapperLeft__quKy5`,
	"overlay": `promoStories-module_overlay__vVZem`,
	"storiesContent": `promoStories-module_storiesContent__m1CPT`,
	"progressRow": `promoStories-module_progressRow__FCV1u`,
	"step": `promoStories-module_step__JYzq6`,
	"stepInverted": `promoStories-module_stepInverted__z6myk`,
	"stepBg": `promoStories-module_stepBg__D4An4`,
	"stepBgInverted": `promoStories-module_stepBgInverted__Y_3AK`,
	"storyContainer": `promoStories-module_storyContainer__mDo6V`,
	"bottomButtonsWrapper": `promoStories-module_bottomButtonsWrapper__Hh2B7`,
	"justifyCenter": `promoStories-module_justifyCenter__pfcsr`,
	"storyBottomButtons": `promoStories-module_storyBottomButtons__I1o5Q`,
	"storyContentButton": `promoStories-module_storyContentButton__RjBjv`,
	"storyInfo": `promoStories-module_storyInfo__i09I7`,
	"storyInfoMiddle": `promoStories-module_storyInfoMiddle__tCqAh`,
	"storyImg": `promoStories-module_storyImg__OR1P8`,
	"storyContent": `promoStories-module_storyContent__FlqBZ`,
	"storyContentTop": `promoStories-module_storyContentTop__kBtmW`,
	"fullWidthImage": `promoStories-module_fullWidthImage__RvAcG`,
	"forward": `promoStories-module_forward__at36L`,
	"animatedContent": `promoStories-module_animatedContent__xktoh`,
	"slideRightToLeft": `promoStories-module_slideRightToLeft__g92D3`,
	"backwards": `promoStories-module_backwards__h7ZYY`,
	"slideLeftToRight": `promoStories-module_slideLeftToRight__jSE47`
};
export default ___CSS_LOADER_EXPORT___;
